/**
 * @module app.cm
 */

import { DynamicViews } from 'app/shared/config/modules';
import { PLATFORM } from 'aurelia-pal';

export function getCaseManagementQueueNavigationTypes(): DynamicViews {
    return {
        'CM.Routing': [
            {
                title: 'cm:queueTypes.routing.$title',
                url: PLATFORM.moduleName('app/cm/components/queues/routing-queue-navigation')
            }
        ]
    };
}
